import lang from 'lang.js'
let messages = require('./messages')

const Lang = new lang({
    messages,
})

const frontElm = document.querySelector('#front')

if (frontElm !== null) {
    const locale = frontElm.dataset.frontLocale
    Lang.setLocale(locale)
}

export default Lang
